
















































































































































































import { germanZipRule } from "@/lib/rules/contactRule";
import { beforeCurrentDateRule, dateRule } from "@/lib/rules/dateRule";
import { isNumberRule } from "@/lib/rules/isNumberRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ChargingPointConnector, ChargingPointType } from "@/store/models/thg/create-charging-point";
import { CreateChargingStation } from "@/store/models/thg/create-charging-station";
import { CreateChargingStationOperator } from "@/store/models/thg/create-charging-station-opereator";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { numberLowerRule } from "@/lib/rules/numberLowerRule";

@Component({
  components: {}
})
export default class ThgChargingStationForm extends Vue {
  chargingStation = new CreateChargingStation();
  chargingPointOperator = new CreateChargingStationOperator();

  isCompany = true;
  isResubmittingTaxnumber = false;
  taxnumber = "";

  isDatepickerMenuActive = false;
  activePicker = "YEAR";

  selectedDay = "";
  selectedMonth = "";
  selectedYear = "";

  minChargingPointAmount = 1;
  maxChargingPointAmount = 4;

  minConnectionPower = 1;

  valid = false;

  get isRegisteredItems() {
    return [
      { text: this.$t("components.thg.ThgChargingStationForm.isCompany.true"), value: true },
      { text: this.$t("components.thg.ThgChargingStationForm.isCompany.false"), value: false }
    ];
  }
  get germanZipRule() {
    return [germanZipRule(), requiredRule()];
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get dateRule() {
    return [dateRule(), beforeCurrentDateRule()];
  }

  get numberRule() {
    return [isNumberRule(), requiredRule()];
  }

  get chargingPointNumberRule() {
    return [
      isNumberRule(),
      requiredRule(),
      numberHigherRule(this.minChargingPointAmount),
      numberLowerRule(this.maxChargingPointAmount)
    ];
  }

  get connectionPowerRule() {
    return [isNumberRule(), requiredRule(), numberHigherRule(this.minConnectionPower)];
  }

  get chargingPointTypes() {
    return ChargingPointType;
  }

  get chargingPointConnector() {
    return ChargingPointConnector;
  }

  mounted() {
    this.chargingPointOperator = CreateChargingStationOperator.createFromUser(UserModule.user);
  }

  save() {
    this.chargingStation.chargingPointOperator = this.chargingPointOperator;
    this.chargingStation.commissioningDate = `${this.selectedYear}-${this.selectedMonth}-${this.selectedDay}`;

    this.$emit("save", this.chargingStation);
  }

  day = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31"
  ];

  month = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

  /**
   * Get range of allowed years, including "next year".
   */
  get year(): number[] {
    const currentYear = new Date().getFullYear();

    const nextYear = currentYear + 1;
    const youngestYear = 2000;

    return this.range(youngestYear, nextYear);
  }

  /**
   * Returns an array range from start to end.
   *
   * @param start the first element of the list
   * @param end the last element of the list
   */
  range(start: number, end: number) {
    return [...Array(1 + end - start).keys()].map(v => start + v);
  }
}
